export default "__VITE_ASSET__Doa6sv3F__"